import React from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";

const BASE_PHONE = "5215515555555"; // TODO: replace with real number when client provides it
const PATH_MESSAGES = {
  "/parrilladas": "¡Qué onda compare! Quiero info para una parrillada a domicilio.",
  "/arre-box": "¡Qué onda compare! Tengo dudas del Arre Box (suscripción).",
  "/empresas": "¡Qué onda compare! Necesito una cotización corporativa.",
  "/regalo": "¡Qué onda compare! Quiero info de las tarjetas regalo.",
  "/carrito": "¡Qué onda compare! Tengo dudas con un pedido en mi carrito.",
  "/checkout": "¡Qué onda compare! Tengo dudas con mi pedido.",
  "/rastreo": "¡Qué onda compare! Necesito ayuda con el rastreo de mi pedido.",
};

function pickMessage(pathname) {
  if (pathname.startsWith("/producto/")) return "¡Qué onda compare! Tengo una duda sobre este corte.";
  if (pathname.startsWith("/paquete/")) return "¡Qué onda compare! Tengo una duda sobre este paquete.";
  if (pathname.startsWith("/blog/")) return "¡Qué onda compare! Vi un artículo en su blog y tengo una duda.";
  return PATH_MESSAGES[pathname] || "¡Qué onda compare! Tengo una pregunta sobre Arre Sonora.";
}

export default function WhatsAppFloat() {
  const { pathname } = useLocation();

  if (pathname.startsWith("/admin") || pathname.startsWith("/login")) return null;

  const text = encodeURIComponent(pickMessage(pathname));
  const href = `https://wa.me/${BASE_PHONE}?text=${text}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-float"
      className="fixed bottom-20 right-5 md:bottom-8 md:right-8 z-50 group"
    >
      <span className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-20" />
      <span className="relative flex items-center gap-2 bg-[#25D366] hover:bg-[#1fb858] text-white shadow-2xl rounded-full pl-3 pr-4 py-3 transition-all hover:pl-4 hover:pr-5">
        <MessageCircle className="w-6 h-6" strokeWidth={2.2} />
        <span className="hidden md:inline font-display text-xs tracking-[0.2em] uppercase">
          Chatea con nosotros
        </span>
      </span>
    </a>
  );
}
